import { put, call, takeLatest, select } from 'typed-redux-saga'
import { errorHandler, loadersSlice } from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'
import { fetchEntity } from 'Src/modules/page'
import {
	contractsSelectors,
	contractsApi,
	ContractsNS,
	contractsSlice,
	TagType,
	partnersSlice,
} from 'Pages/partner'

function* getTags(action: ContractsNS.GetTags) {
	try {
		yield* put(contractsSlice.actions.setIsLoading(true))
		const { params, clear } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(contractsSlice.actions.clearAll())
		}
		const res = yield* call(contractsApi.getTags, requestParams)
		const tags = new ResponseCatalog<TagType>(res)
		if (!clear) {
			const oldTags = yield* select(contractsSelectors.tags)
			tags.entries = oldTags.concat(res.entries)
		}
		yield* put(contractsSlice.actions.setTags(tags))
		yield* put(contractsSlice.actions.setTagsRequestParams(requestParams))
		yield* put(contractsSlice.actions.setIsLoading(false))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(contractsSlice.actions.setIsLoading(false))
	}
}

function* createOne(action: ContractsNS.CreateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(
			contractsApi.createOne,
			action.payload.partner_id,
			action.payload.document_type,
			action.payload.data
		)
		yield* put(contractsSlice.actions.getContacts())
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* updateOne(action: ContractsNS.UpdateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(
			contractsApi.updateOne,
			action.payload.partner_id,
			action.payload.id,
			action.payload.data
		)
		yield* put(contractsSlice.actions.getContacts())
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* deleteOne(action: ContractsNS.DeleteOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(contractsApi.deleteOne, action.payload.partner_id, action.payload.id)
		yield* put(contractsSlice.actions.getContacts())
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* getContacts(action: ContractsNS.GetContacts) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const partnerId = yield* select(contractsSelectors.partnerId)
		// @ts-ignore
		yield* put(fetchEntity({ url: `/partner/${partnerId}`, key: 'partner' }))
		yield* put(partnersSlice.actions.getDocuments(partnerId))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* contractsSaga() {
	yield* takeLatest(contractsSlice.actions.createOne, createOne)
	yield* takeLatest(contractsSlice.actions.updateOne, updateOne)
	yield* takeLatest(contractsSlice.actions.deleteOne, deleteOne)
	yield* takeLatest(contractsSlice.actions.getTags, getTags)
	yield* takeLatest(contractsSlice.actions.getContacts, getContacts)
}
